import { GraphQLClient } from 'graphql-request';
import * as Dom from 'graphql-request/dist/types.dom';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /**
   * The `Date` scalar type represents a Date
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Date: any;
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: any;
  /** The `Decimal` scalar type represents a python Decimal. */
  Decimal: any;
};

export type ApiAuthType = {
  apiKey: Scalars['String'];
  id: Scalars['ID'];
  secretKey: Scalars['String'];
};

/** An enumeration. */
export enum AppOtcAdActionChoices {
  /** Buy */
  Buy = 'BUY',
  /** Sell */
  Sell = 'SELL'
}

/** An enumeration. */
export enum AppOtcAdCurrencyChoices {
  /** Aed */
  Aed = 'AED',
  /** Btc */
  Btc = 'BTC',
  /** Fnk */
  Fnk = 'FNK',
  /** Kzt */
  Kzt = 'KZT',
  /** Ltc */
  Ltc = 'LTC',
  /** Partner */
  Partner = 'PARTNER',
  /** Rub */
  Rub = 'RUB',
  /** Usdt */
  Usdt = 'USDT',
  /** Uzs */
  Uzs = 'UZS',
  /** Xmr */
  Xmr = 'XMR'
}

/** An enumeration. */
export enum AppOtcAdPriceExtraPercentDirectionChoices {
  /** Creator */
  Creator = 'CREATOR',
  /** Customer */
  Customer = 'CUSTOMER'
}

/** An enumeration. */
export enum AppOtcAdStatusChoices {
  /** Active */
  Active = 'ACTIVE',
  /** Completed */
  Completed = 'COMPLETED'
}

/** An enumeration. */
export enum AppOtcDealStateChoices {
  /** Принято */
  Accepted = 'ACCEPTED',
  /** Отменено */
  Canceled = 'CANCELED',
  /** Завершено */
  Complete = 'COMPLETE',
  /** Создано */
  Created = 'CREATED',
  /** Предложено */
  Offered = 'OFFERED',
  /** Оплачено */
  Paid = 'PAID'
}

/** An enumeration. */
export enum AppOtcDealStatusChoices {
  /** Активно */
  Active = 'ACTIVE',
  /** Арбитраж */
  Arbitrage = 'ARBITRAGE',
  /** Отменено */
  Canceled = 'CANCELED',
  /** Завершено */
  Completed = 'COMPLETED'
}

/** An enumeration. */
export enum AppOperationLogCurrencyChoices {
  /** Aed */
  Aed = 'AED',
  /** Btc */
  Btc = 'BTC',
  /** Fnk */
  Fnk = 'FNK',
  /** Kzt */
  Kzt = 'KZT',
  /** Ltc */
  Ltc = 'LTC',
  /** Partner */
  Partner = 'PARTNER',
  /** Rub */
  Rub = 'RUB',
  /** Usdt */
  Usdt = 'USDT',
  /** Uzs */
  Uzs = 'UZS',
  /** Xmr */
  Xmr = 'XMR'
}

/** An enumeration. */
export enum AppOperationLogTypeChoices {
  /** Deposit */
  Deposit = 'DEPOSIT',
  /** Withdraw */
  Withdraw = 'WITHDRAW'
}

export type BalanceExchangeType = {
  balance?: Maybe<Scalars['Decimal']>;
  freezeBalance?: Maybe<Scalars['Decimal']>;
  symbol: ExchangeExchangeBalanceSymbolChoices;
};

export type BookDataType = {
  buy?: Maybe<Array<Maybe<ExchangeOrdersType>>>;
  sell?: Maybe<Array<Maybe<ExchangeOrdersType>>>;
};

/** Мутация для проверки статуса EXMO кода. */
export type CheckExmoCodeMutation = {
  error?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type CoinType = {
  baseCoinScale: Scalars['Int'];
  baseSymbol: ExchangeExchangeCoinBasesymbolChoices;
  coinScale: Scalars['Int'];
  coinSymbol: ExchangeExchangeCoinCoinsymbolChoices;
  enable: Scalars['Boolean'];
  fee: Scalars['Decimal'];
  rubRate: Scalars['Decimal'];
  symbol: Scalars['String'];
  usdRate: Scalars['Decimal'];
};

export type CreateApiAuthMutation = {
  ok?: Maybe<Scalars['Boolean']>;
};

/** Мутация для создания EXMO кода. */
export type CreateExmoCodeMutation = {
  error?: Maybe<Scalars['String']>;
  exmoCode?: Maybe<ExmoCodeType>;
};

export type CreateOrderMutation = {
  ok?: Maybe<Scalars['Boolean']>;
};




export type DeleteApiAuthMutation = {
  ok?: Maybe<Scalars['Boolean']>;
};

export type DepositAedMutation = {
  ok?: Maybe<Scalars['Boolean']>;
};

export type DepositKztMutation = {
  ok?: Maybe<Scalars['Boolean']>;
};

export type DepositRubMutation = {
  ok?: Maybe<Scalars['Boolean']>;
};

export type DepositUzsMutation = {
  ok?: Maybe<Scalars['Boolean']>;
};

/** An enumeration. */
export enum ExchangeExchangeBalanceSymbolChoices {
  /** Aed */
  Aed = 'AED',
  /** Btc */
  Btc = 'BTC',
  /** Kzt */
  Kzt = 'KZT',
  /** Ltc */
  Ltc = 'LTC',
  /** Rub */
  Rub = 'RUB',
  /** Usdt */
  Usdt = 'USDT',
  /** Uzs */
  Uzs = 'UZS',
  /** Xmr */
  Xmr = 'XMR'
}

/** An enumeration. */
export enum ExchangeExchangeCoinBasesymbolChoices {
  /** Aed */
  Aed = 'AED',
  /** Btc */
  Btc = 'BTC',
  /** Kzt */
  Kzt = 'KZT',
  /** Ltc */
  Ltc = 'LTC',
  /** Rub */
  Rub = 'RUB',
  /** Usdt */
  Usdt = 'USDT',
  /** Uzs */
  Uzs = 'UZS',
  /** Xmr */
  Xmr = 'XMR'
}

/** An enumeration. */
export enum ExchangeExchangeCoinCoinsymbolChoices {
  /** Aed */
  Aed = 'AED',
  /** Btc */
  Btc = 'BTC',
  /** Kzt */
  Kzt = 'KZT',
  /** Ltc */
  Ltc = 'LTC',
  /** Rub */
  Rub = 'RUB',
  /** Usdt */
  Usdt = 'USDT',
  /** Uzs */
  Uzs = 'UZS',
  /** Xmr */
  Xmr = 'XMR'
}

/** An enumeration. */
export enum ExchangeExchangeOrderBasesymbolChoices {
  /** Aed */
  Aed = 'AED',
  /** Btc */
  Btc = 'BTC',
  /** Kzt */
  Kzt = 'KZT',
  /** Ltc */
  Ltc = 'LTC',
  /** Rub */
  Rub = 'RUB',
  /** Usdt */
  Usdt = 'USDT',
  /** Uzs */
  Uzs = 'UZS',
  /** Xmr */
  Xmr = 'XMR'
}

/** An enumeration. */
export enum ExchangeExchangeOrderCoinsymbolChoices {
  /** Aed */
  Aed = 'AED',
  /** Btc */
  Btc = 'BTC',
  /** Kzt */
  Kzt = 'KZT',
  /** Ltc */
  Ltc = 'LTC',
  /** Rub */
  Rub = 'RUB',
  /** Usdt */
  Usdt = 'USDT',
  /** Uzs */
  Uzs = 'UZS',
  /** Xmr */
  Xmr = 'XMR'
}

/** An enumeration. */
export enum ExchangeExchangeOrderDirectionChoices {
  /** Buy */
  Buy = 'BUY',
  /** Sell */
  Sell = 'SELL'
}

/** An enumeration. */
export enum ExchangeExchangeOrderStatusChoices {
  /** Canceled */
  Canceled = 'CANCELED',
  /** Completed */
  Completed = 'COMPLETED',
  /** Overtimed */
  Overtimed = 'OVERTIMED',
  /** Trading */
  Trading = 'TRADING'
}

/** An enumeration. */
export enum ExchangeExchangeOrderTypeChoices {
  /** Limit Price */
  Limit = 'LIMIT',
  /** Market Price */
  Market = 'MARKET'
}

/** An enumeration. */
export enum ExchangeExmoCodeCurrencyChoices {
  /** Aed */
  Aed = 'AED',
  /** Btc */
  Btc = 'BTC',
  /** Kzt */
  Kzt = 'KZT',
  /** Ltc */
  Ltc = 'LTC',
  /** Rub */
  Rub = 'RUB',
  /** Usdt */
  Usdt = 'USDT',
  /** Uzs */
  Uzs = 'UZS',
  /** Xmr */
  Xmr = 'XMR'
}

export type ExchangeOrderType = {
  amount: Scalars['Decimal'];
  baseSymbol: ExchangeExchangeOrderBasesymbolChoices;
  coinSymbol: ExchangeExchangeOrderCoinsymbolChoices;
  direction: ExchangeExchangeOrderDirectionChoices;
  orderId: Scalars['ID'];
  price: Scalars['Decimal'];
  remainingAmount?: Maybe<Scalars['String']>;
  status: ExchangeExchangeOrderStatusChoices;
  symbol: Scalars['String'];
  time?: Maybe<Scalars['DateTime']>;
  timeCanceled?: Maybe<Scalars['DateTime']>;
  timeComplited?: Maybe<Scalars['DateTime']>;
  tradedAmount: Scalars['Decimal'];
  tradedTurnover: Scalars['Decimal'];
  turnover: Scalars['Decimal'];
  type: ExchangeExchangeOrderTypeChoices;
};

export type ExchangeOrdersType = {
  amountMyOrder?: Maybe<Scalars['String']>;
  amounts?: Maybe<Scalars['Decimal']>;
  price?: Maybe<Scalars['Decimal']>;
  symbol?: Maybe<Scalars['String']>;
  turnovers?: Maybe<Scalars['Decimal']>;
  type?: Maybe<Scalars['String']>;
};

/** Тип GraphQL для модели ExmoCode. */
export type ExmoCodeType = {
  activatedAt?: Maybe<Scalars['DateTime']>;
  amount: Scalars['Decimal'];
  code: Scalars['String'];
  createdAt: Scalars['DateTime'];
  currency: ExchangeExmoCodeCurrencyChoices;
  id: Scalars['ID'];
  readByUser?: Maybe<ProfileType>;
  status: Scalars['String'];
  user?: Maybe<ProfileType>;
};

export type IndexPageInfoType = {
  bottomImage1?: Maybe<Scalars['String']>;
  bottomImage2?: Maybe<Scalars['String']>;
  bottomImage3?: Maybe<Scalars['String']>;
  bottomText1?: Maybe<Scalars['String']>;
  bottomText2?: Maybe<Scalars['String']>;
  bottomText3?: Maybe<Scalars['String']>;
  topImage?: Maybe<Scalars['String']>;
  topText?: Maybe<Scalars['String']>;
};

export type KycType = {
  clientKey?: Maybe<Scalars['String']>;
  needsKyc?: Maybe<Scalars['Boolean']>;
  schemaId?: Maybe<Scalars['String']>;
};

export type LightningCreateDepositInvoice = {
  ok?: Maybe<Scalars['Boolean']>;
  /** BOLT11 invoice для оплаты */
  paymentRequest?: Maybe<Scalars['String']>;
  /** Payment hash (hex) */
  rHash?: Maybe<Scalars['String']>;
};

export type LightningPayInvoice = {
  ok?: Maybe<Scalars['Boolean']>;
  /** Ошибка, если есть */
  paymentError?: Maybe<Scalars['String']>;
  /** Payment preimage (hex) */
  paymentPreimage?: Maybe<Scalars['String']>;
};

export type Mutation = {
  cancelOrder?: Maybe<OrderCancelMutation>;
  /** Мутация для проверки статуса EXMO кода. */
  checkExmoCode?: Maybe<CheckExmoCodeMutation>;
  createApiAuth?: Maybe<CreateApiAuthMutation>;
  /** Мутация для создания EXMO кода. */
  createExmoCode?: Maybe<CreateExmoCodeMutation>;
  createLnDepositInvoice?: Maybe<LightningCreateDepositInvoice>;
  createOrder?: Maybe<CreateOrderMutation>;
  deleteApiAuth?: Maybe<DeleteApiAuthMutation>;
  depositAed?: Maybe<DepositAedMutation>;
  depositKzt?: Maybe<DepositKztMutation>;
  depositRub?: Maybe<DepositRubMutation>;
  depositUzs?: Maybe<DepositUzsMutation>;
  otcCreateAd?: Maybe<OtcCreateAdMutation>;
  otcDealAccept?: Maybe<OtcDealAcceptMutation>;
  otcDealArbitrage?: Maybe<OtcDealArbitrageMutation>;
  otcDealCancel?: Maybe<OtcDealCancelMutation>;
  otcDealComplete?: Maybe<OtcDealCompleteMutation>;
  otcDealDecline?: Maybe<OtcDealDeclineMutation>;
  otcDealOffer?: Maybe<OtcDealOfferMutation>;
  otcDealPaid?: Maybe<OtcDealPaidMutation>;
  otcDeleteAd?: Maybe<OtcDeleteAdMutation>;
  otcEditAd?: Maybe<OtcEditAdMutation>;
  otcSetActiveAd?: Maybe<OtcSetActiveAdMutation>;
  otcStartDeal?: Maybe<OtcStartDealMutation>;
  passwordReset?: Maybe<PasswordResetMutation>;
  payLnInvoice?: Maybe<LightningPayInvoice>;
  /** Мутация для активации EXMO кода. */
  redeemExmoCode?: Maybe<RedeemExmoCodeMutation>;
  register?: Maybe<RegisterMutation>;
  toggle2fa?: Maybe<Toggle2FaMutation>;
  tokenAuth?: Maybe<TokenAuthMutation>;
  tokenAuthTg?: Maybe<TokenAuthTgMutation>;
  updateAvatar?: Maybe<UpdateAvatarMutation>;
  updateName?: Maybe<UpdateNameMutation>;
  updatePassword?: Maybe<UpdatePasswordMutation>;
  updatePhone?: Maybe<UpdatePhoneMutation>;
  updateTg?: Maybe<UpdateTgMutation>;
  withdrawAed?: Maybe<WithdrawAedMutation>;
  withdrawBtc?: Maybe<WithdrawBtcMutation>;
  withdrawFnk?: Maybe<WithdrawFnkMutation>;
  withdrawKzt?: Maybe<WithdrawKztMutation>;
  withdrawLtc?: Maybe<WithdrawLtcMutation>;
  withdrawPartner?: Maybe<WithdrawPartnerMutation>;
  withdrawRub?: Maybe<WithdrawRubMutation>;
  withdrawUsdt?: Maybe<WithdrawUsdtMutation>;
  withdrawUzs?: Maybe<WithdrawUzsMutation>;
  withdrawXmr?: Maybe<WithdrawXmrMutation>;
};


export type Mutation_CancelOrderArgs = {
  pk: Scalars['String'];
};


export type Mutation_CheckExmoCodeArgs = {
  code: Scalars['String'];
};


export type Mutation_CreateExmoCodeArgs = {
  amount: Scalars['Decimal'];
  currency: Scalars['String'];
};


export type Mutation_CreateLnDepositInvoiceArgs = {
  amountBtc: Scalars['Decimal'];
};


export type Mutation_CreateOrderArgs = {
  amount: Scalars['Decimal'];
  direction: Scalars['String'];
  price: Scalars['Decimal'];
  symbol: Scalars['String'];
  turnover: Scalars['Decimal'];
  type: Scalars['String'];
};


export type Mutation_DeleteApiAuthArgs = {
  id: Scalars['ID'];
};


export type Mutation_DepositAedArgs = {
  code?: Maybe<Scalars['String']>;
};


export type Mutation_DepositKztArgs = {
  code?: Maybe<Scalars['String']>;
};


export type Mutation_DepositRubArgs = {
  code?: Maybe<Scalars['String']>;
};


export type Mutation_DepositUzsArgs = {
  code?: Maybe<Scalars['String']>;
};


export type Mutation_OtcCreateAdArgs = {
  action: Scalars['String'];
  bankCardNumber?: Maybe<Scalars['String']>;
  currency: Scalars['String'];
  description: Scalars['String'];
  maxSum: Scalars['Decimal'];
  minSum: Scalars['Decimal'];
  paymentMethod: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
  priceExtraPercent: Scalars['Decimal'];
  priceExtraPercentDirection: Scalars['String'];
};


export type Mutation_OtcDealAcceptArgs = {
  pk: Scalars['String'];
};


export type Mutation_OtcDealArbitrageArgs = {
  pk: Scalars['String'];
};


export type Mutation_OtcDealCancelArgs = {
  pk: Scalars['String'];
};


export type Mutation_OtcDealCompleteArgs = {
  pk: Scalars['String'];
};


export type Mutation_OtcDealDeclineArgs = {
  pk: Scalars['String'];
};


export type Mutation_OtcDealOfferArgs = {
  amount: Scalars['Decimal'];
  bankCardNumber?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  pk: Scalars['String'];
};


export type Mutation_OtcDealPaidArgs = {
  pk: Scalars['String'];
};


export type Mutation_OtcDeleteAdArgs = {
  pk: Scalars['String'];
};


export type Mutation_OtcEditAdArgs = {
  action: Scalars['String'];
  bankCardNumber?: Maybe<Scalars['String']>;
  currency: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['String'];
  maxSum: Scalars['Decimal'];
  minSum: Scalars['Decimal'];
  paymentMethod: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
  priceExtraPercent: Scalars['Decimal'];
  priceExtraPercentDirection: Scalars['String'];
};


export type Mutation_OtcSetActiveAdArgs = {
  isActive: Scalars['Boolean'];
  pk: Scalars['String'];
};


export type Mutation_OtcStartDealArgs = {
  adId: Scalars['String'];
};


export type Mutation_PasswordResetArgs = {
  email: Scalars['String'];
};


export type Mutation_PayLnInvoiceArgs = {
  amountBtc: Scalars['Decimal'];
  lnInvoiceStr: Scalars['String'];
  otpCode?: Maybe<Scalars['String']>;
};


export type Mutation_RedeemExmoCodeArgs = {
  code: Scalars['String'];
};


export type Mutation_RegisterArgs = {
  email: Scalars['String'];
  name: Scalars['String'];
  password: Scalars['String'];
  referrer?: Maybe<Scalars['String']>;
};


export type Mutation_Toggle2faArgs = {
  code: Scalars['String'];
};


export type Mutation_TokenAuthArgs = {
  email: Scalars['String'];
  otpCode: Scalars['String'];
  password: Scalars['String'];
};


export type Mutation_TokenAuthTgArgs = {
  authDate: Scalars['Int'];
  firstName: Scalars['String'];
  hash: Scalars['String'];
  id: Scalars['Int'];
  photoUrl: Scalars['String'];
  username: Scalars['String'];
};


export type Mutation_UpdateAvatarArgs = {
  avatar: Scalars['String'];
};


export type Mutation_UpdateNameArgs = {
  newName: Scalars['String'];
};


export type Mutation_UpdatePasswordArgs = {
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
};


export type Mutation_UpdatePhoneArgs = {
  newPhone: Scalars['String'];
};


export type Mutation_UpdateTgArgs = {
  inviterTgUsername?: Maybe<Scalars['String']>;
  tgUsername: Scalars['String'];
};


export type Mutation_WithdrawAedArgs = {
  amount?: Maybe<Scalars['Decimal']>;
  otpCode?: Maybe<Scalars['String']>;
};


export type Mutation_WithdrawBtcArgs = {
  address?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Decimal']>;
  otpCode?: Maybe<Scalars['String']>;
};


export type Mutation_WithdrawFnkArgs = {
  address?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Decimal']>;
  otpCode?: Maybe<Scalars['String']>;
};


export type Mutation_WithdrawKztArgs = {
  amount?: Maybe<Scalars['Decimal']>;
  otpCode?: Maybe<Scalars['String']>;
};


export type Mutation_WithdrawLtcArgs = {
  address?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Decimal']>;
  otpCode?: Maybe<Scalars['String']>;
};


export type Mutation_WithdrawPartnerArgs = {
  amount?: Maybe<Scalars['Decimal']>;
  otpCode?: Maybe<Scalars['String']>;
};


export type Mutation_WithdrawRubArgs = {
  amount?: Maybe<Scalars['Decimal']>;
  otpCode?: Maybe<Scalars['String']>;
};


export type Mutation_WithdrawUsdtArgs = {
  address?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Decimal']>;
  otpCode?: Maybe<Scalars['String']>;
};


export type Mutation_WithdrawUzsArgs = {
  amount?: Maybe<Scalars['Decimal']>;
  otpCode?: Maybe<Scalars['String']>;
};


export type Mutation_WithdrawXmrArgs = {
  address?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Decimal']>;
  otpCode?: Maybe<Scalars['String']>;
};

export type OtcAdType = {
  action: AppOtcAdActionChoices;
  bankCardNumber?: Maybe<Scalars['String']>;
  currency: AppOtcAdCurrencyChoices;
  description: Scalars['String'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  maxSum: Scalars['Decimal'];
  minSum: Scalars['Decimal'];
  paymentMethod: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
  priceExtraPercent: Scalars['Decimal'];
  priceExtraPercentDirection: AppOtcAdPriceExtraPercentDirectionChoices;
  status: AppOtcAdStatusChoices;
  user?: Maybe<ReferralType>;
};

export type OtcAdsType = {
  buy?: Maybe<Array<OtcAdType>>;
  sell?: Maybe<Array<OtcAdType>>;
};

export type OtcCreateAdMutation = {
  ok?: Maybe<Scalars['Boolean']>;
};

export type OtcDealAcceptMutation = {
  ok?: Maybe<Scalars['Boolean']>;
};

export type OtcDealArbitrageMutation = {
  ok?: Maybe<Scalars['Boolean']>;
};

export type OtcDealCancelMutation = {
  ok?: Maybe<Scalars['Boolean']>;
};

export type OtcDealCompleteMutation = {
  ok?: Maybe<Scalars['Boolean']>;
};

export type OtcDealDeclineMutation = {
  ok?: Maybe<Scalars['Boolean']>;
};

export type OtcDealOfferMutation = {
  ok?: Maybe<Scalars['Boolean']>;
};

export type OtcDealPaidMutation = {
  ok?: Maybe<Scalars['Boolean']>;
};

export type OtcDealType = {
  ad?: Maybe<OtcAdType>;
  amount?: Maybe<Scalars['Decimal']>;
  bankCardNumber?: Maybe<Scalars['String']>;
  datetime: Scalars['DateTime'];
  hasUnread?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  paymentMethod?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  state: AppOtcDealStateChoices;
  status: AppOtcDealStatusChoices;
  user?: Maybe<ReferralType>;
};

export type OtcDeleteAdMutation = {
  ok?: Maybe<Scalars['Boolean']>;
};

export type OtcEditAdMutation = {
  ok?: Maybe<Scalars['Boolean']>;
};

export type OtcSetActiveAdMutation = {
  ok?: Maybe<Scalars['Boolean']>;
};

export type OtcStartDealMutation = {
  dealId?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type OperationLogType = {
  currency: AppOperationLogCurrencyChoices;
  datetime: Scalars['DateTime'];
  destination: Scalars['String'];
  id: Scalars['ID'];
  status?: Maybe<Scalars['Boolean']>;
  txid?: Maybe<Scalars['String']>;
  type: AppOperationLogTypeChoices;
  value: Scalars['Decimal'];
};

export type OperationsType = {
  deposits?: Maybe<Array<OperationLogType>>;
  withdraws?: Maybe<Array<OperationLogType>>;
};

export type OrderCancelMutation = {
  ok?: Maybe<Scalars['Boolean']>;
};

export type PageListType = {
  count?: Maybe<Scalars['Int']>;
  items?: Maybe<Array<ExchangeOrderType>>;
  limit?: Maybe<Scalars['Int']>;
  pageNo?: Maybe<Scalars['Int']>;
};

export type PasswordResetMutation = {
  ok?: Maybe<Scalars['Boolean']>;
};

export type ProfileType = {
  aedBalance: Scalars['Decimal'];
  avatar?: Maybe<Scalars['String']>;
  btcAddress?: Maybe<Scalars['String']>;
  btcBalance: Scalars['Decimal'];
  email: Scalars['String'];
  emailValidated: Scalars['Boolean'];
  ethAddress?: Maybe<Scalars['String']>;
  fnkBalance: Scalars['Decimal'];
  id: Scalars['ID'];
  inviterTgUsername?: Maybe<Scalars['String']>;
  /** KYC‐статус и данные */
  kyc?: Maybe<KycType>;
  kztBalance: Scalars['Decimal'];
  lockedBtc?: Maybe<Scalars['Decimal']>;
  lockedFnk?: Maybe<Scalars['Decimal']>;
  lockedUsdt?: Maybe<Scalars['Decimal']>;
  ltcAddress?: Maybe<Scalars['String']>;
  ltcBalance?: Maybe<Scalars['Decimal']>;
  name: Scalars['String'];
  otpEnabled: Scalars['Boolean'];
  otpSecret?: Maybe<Scalars['String']>;
  partnerBalance: Scalars['Decimal'];
  phone?: Maybe<Scalars['String']>;
  referralCode?: Maybe<Scalars['String']>;
  referrals?: Maybe<Array<ReferralType>>;
  referrer?: Maybe<Scalars['String']>;
  rubBalance: Scalars['Decimal'];
  tgUsername?: Maybe<Scalars['String']>;
  tronAddress?: Maybe<Scalars['String']>;
  usdtBalance: Scalars['Decimal'];
  uzsBalance: Scalars['Decimal'];
  xmrAddress?: Maybe<Scalars['String']>;
  xmrBalance?: Maybe<Scalars['Decimal']>;
};

export type Query = {
  ads?: Maybe<OtcAdsType>;
  apiAuthList?: Maybe<Array<ApiAuthType>>;
  basesymbol?: Maybe<Array<Maybe<Scalars['String']>>>;
  books?: Maybe<BookDataType>;
  coin?: Maybe<CoinType>;
  coins?: Maybe<Array<Maybe<Scalars['String']>>>;
  deal?: Maybe<OtcDealType>;
  estimateBtcFee?: Maybe<Scalars['Decimal']>;
  getBalance?: Maybe<Scalars['Decimal']>;
  getBalancesAll?: Maybe<Array<Maybe<BalanceExchangeType>>>;
  getBalancesOne?: Maybe<BalanceExchangeType>;
  getOperations?: Maybe<OperationsType>;
  has2fa?: Maybe<Scalars['Boolean']>;
  indexPage?: Maybe<IndexPageInfoType>;
  ltcDepositAddress?: Maybe<Scalars['String']>;
  minBtcTransfer?: Maybe<Scalars['Decimal']>;
  myAds?: Maybe<Array<OtcAdType>>;
  myDeals?: Maybe<Array<OtcDealType>>;
  myExmoCodes?: Maybe<Array<Maybe<ExmoCodeType>>>;
  orderCurrent?: Maybe<PageListType>;
  orderHistory?: Maybe<PageListType>;
  profile?: Maybe<ProfileType>;
  xmrDepositAddress?: Maybe<Scalars['String']>;
};


export type Query_BooksArgs = {
  limit?: Maybe<Scalars['Int']>;
  symbol?: Maybe<Scalars['String']>;
};


export type Query_CoinArgs = {
  symbol?: Maybe<Scalars['String']>;
};


export type Query_CoinsArgs = {
  baseSymbol?: Maybe<Scalars['String']>;
};


export type Query_DealArgs = {
  pk?: Maybe<Scalars['String']>;
};


export type Query_EstimateBtcFeeArgs = {
  amount: Scalars['Decimal'];
  confTarget?: Maybe<Scalars['Int']>;
};


export type Query_GetBalanceArgs = {
  symbol: Scalars['String'];
};


export type Query_GetBalancesOneArgs = {
  symbol: Scalars['String'];
};


export type Query_GetOperationsArgs = {
  currency?: Maybe<Scalars['String']>;
};


export type Query_Has2faArgs = {
  email: Scalars['String'];
};


export type Query_MyDealsArgs = {
  endDate?: Maybe<Scalars['Date']>;
  maxAmount?: Maybe<Scalars['Decimal']>;
  minAmount?: Maybe<Scalars['Decimal']>;
  startDate?: Maybe<Scalars['Date']>;
};


export type Query_OrderCurrentArgs = {
  limit?: Maybe<Scalars['Int']>;
  pageNo?: Maybe<Scalars['Int']>;
  symbol?: Maybe<Scalars['String']>;
};


export type Query_OrderHistoryArgs = {
  limit?: Maybe<Scalars['Int']>;
  pageNo?: Maybe<Scalars['Int']>;
  symbol?: Maybe<Scalars['String']>;
};

/** Мутация для активации EXMO кода. */
export type RedeemExmoCodeMutation = {
  error?: Maybe<Scalars['String']>;
  exmoCode?: Maybe<ExmoCodeType>;
};

export type ReferralType = {
  avatar?: Maybe<Scalars['String']>;
  dateJoined: Scalars['DateTime'];
  email: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  referralBonuses: Scalars['Decimal'];
};

export type RegisterMutation = {
  ok?: Maybe<Scalars['Boolean']>;
};

export type Toggle2FaMutation = {
  ok?: Maybe<Scalars['Boolean']>;
};

export type TokenAuthMutation = {
  token?: Maybe<Scalars['String']>;
};

export type TokenAuthTgMutation = {
  token?: Maybe<Scalars['String']>;
};

export type UpdateAvatarMutation = {
  ok?: Maybe<Scalars['Boolean']>;
};

export type UpdateNameMutation = {
  ok?: Maybe<Scalars['Boolean']>;
};

export type UpdatePasswordMutation = {
  ok?: Maybe<Scalars['Boolean']>;
};

export type UpdatePhoneMutation = {
  ok?: Maybe<Scalars['Boolean']>;
};

export type UpdateTgMutation = {
  ok: Scalars['String'];
};

export type WithdrawAedMutation = {
  ok?: Maybe<Scalars['Boolean']>;
};

export type WithdrawBtcMutation = {
  ok?: Maybe<Scalars['Boolean']>;
};

export type WithdrawFnkMutation = {
  ok?: Maybe<Scalars['Boolean']>;
};

export type WithdrawKztMutation = {
  ok?: Maybe<Scalars['Boolean']>;
};

export type WithdrawLtcMutation = {
  ok?: Maybe<Scalars['Boolean']>;
};

export type WithdrawPartnerMutation = {
  ok?: Maybe<Scalars['Boolean']>;
};

export type WithdrawRubMutation = {
  ok?: Maybe<Scalars['Boolean']>;
};

export type WithdrawUsdtMutation = {
  ok?: Maybe<Scalars['Boolean']>;
};

export type WithdrawUzsMutation = {
  ok?: Maybe<Scalars['Boolean']>;
};

export type WithdrawXmrMutation = {
  ok?: Maybe<Scalars['Boolean']>;
};

export type TokenAuthVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
  otpCode: Scalars['String'];
}>;


export type TokenAuth = { tokenAuth?: Maybe<Pick<TokenAuthMutation, 'token'>> };

export type RegisterVariables = Exact<{
  name: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
  referrer?: Maybe<Scalars['String']>;
}>;


export type Register = { register?: Maybe<Pick<RegisterMutation, 'ok'>> };

export type PasswordResetVariables = Exact<{
  email: Scalars['String'];
}>;


export type PasswordReset = { passwordReset?: Maybe<Pick<PasswordResetMutation, 'ok'>> };

export type UpdateAvatarVariables = Exact<{
  avatar: Scalars['String'];
}>;


export type UpdateAvatar = { updateAvatar?: Maybe<Pick<UpdateAvatarMutation, 'ok'>> };

export type UpdateNameVariables = Exact<{
  name: Scalars['String'];
}>;


export type UpdateName = { updateName?: Maybe<Pick<UpdateNameMutation, 'ok'>> };

export type UpdatePasswordVariables = Exact<{
  oldPassword: Scalars['String'];
  newPassword: Scalars['String'];
}>;


export type UpdatePassword = { updatePassword?: Maybe<Pick<UpdatePasswordMutation, 'ok'>> };

export type UpdatePhoneVariables = Exact<{
  phone: Scalars['String'];
}>;


export type UpdatePhone = { updatePhone?: Maybe<Pick<UpdatePhoneMutation, 'ok'>> };

export type Toggle2faVariables = Exact<{
  code: Scalars['String'];
}>;


export type Toggle2fa = { toggle2fa?: Maybe<Pick<Toggle2FaMutation, 'ok'>> };

export type TokenAuthTgVariables = Exact<{
  id: Scalars['Int'];
  firstName: Scalars['String'];
  username: Scalars['String'];
  photoUrl: Scalars['String'];
  authDate: Scalars['Int'];
  hash: Scalars['String'];
}>;


export type TokenAuthTg = { tokenAuthTg?: Maybe<Pick<TokenAuthTgMutation, 'token'>> };

export type UpdateTgVariables = Exact<{
  tgUsername: Scalars['String'];
  inviterTgUsername?: Maybe<Scalars['String']>;
}>;


export type UpdateTg = { updateTg?: Maybe<Pick<UpdateTgMutation, 'ok'>> };

export type CreateApiAuthVariables = Exact<{ [key: string]: never; }>;


export type CreateApiAuth = { createApiAuth?: Maybe<Pick<CreateApiAuthMutation, 'ok'>> };

export type DeleteApiAuthVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteApiAuth = { deleteApiAuth?: Maybe<Pick<DeleteApiAuthMutation, 'ok'>> };

export type DepositRubVariables = Exact<{
  code: Scalars['String'];
}>;


export type DepositRub = { depositRub?: Maybe<Pick<DepositRubMutation, 'ok'>> };

export type RedeemExmoCodeVariables = Exact<{
  code: Scalars['String'];
}>;


export type RedeemExmoCode = { redeemExmoCode?: Maybe<(
    Pick<RedeemExmoCodeMutation, 'error'>
    & { exmoCode?: Maybe<Pick<ExmoCodeType, 'code' | 'amount' | 'currency' | 'status' | 'activatedAt'>> }
  )> };

export type CheckExmoCodeVariables = Exact<{
  code: Scalars['String'];
}>;


export type CheckExmoCode = { checkExmoCode?: Maybe<Pick<CheckExmoCodeMutation, 'status' | 'error'>> };

export type CreateExmoCodeVariables = Exact<{
  currency: Scalars['String'];
  amount: Scalars['Decimal'];
}>;


export type CreateExmoCode = { createExmoCode?: Maybe<(
    Pick<CreateExmoCodeMutation, 'error'>
    & { exmoCode?: Maybe<Pick<ExmoCodeType, 'code' | 'amount' | 'currency' | 'status' | 'createdAt'>> }
  )> };

export type DepositKztVariables = Exact<{
  code: Scalars['String'];
}>;


export type DepositKzt = { depositKzt?: Maybe<Pick<DepositKztMutation, 'ok'>> };

export type DepositUzsVariables = Exact<{
  code: Scalars['String'];
}>;


export type DepositUzs = { depositUzs?: Maybe<Pick<DepositUzsMutation, 'ok'>> };

export type DepositAedVariables = Exact<{
  code: Scalars['String'];
}>;


export type DepositAed = { depositAed?: Maybe<Pick<DepositAedMutation, 'ok'>> };

export type WithdrawKztVariables = Exact<{
  amount: Scalars['Decimal'];
  otpCode?: Maybe<Scalars['String']>;
}>;


export type WithdrawKzt = { withdrawKzt?: Maybe<Pick<WithdrawKztMutation, 'ok'>> };

export type WithdrawAedVariables = Exact<{
  amount: Scalars['Decimal'];
  otpCode?: Maybe<Scalars['String']>;
}>;


export type WithdrawAed = { withdrawAed?: Maybe<Pick<WithdrawAedMutation, 'ok'>> };

export type WithdrawUzsVariables = Exact<{
  amount: Scalars['Decimal'];
  otpCode?: Maybe<Scalars['String']>;
}>;


export type WithdrawUzs = { withdrawUzs?: Maybe<Pick<WithdrawUzsMutation, 'ok'>> };

export type WithdrawRubVariables = Exact<{
  amount: Scalars['Decimal'];
  otpCode?: Maybe<Scalars['String']>;
}>;


export type WithdrawRub = { withdrawRub?: Maybe<Pick<WithdrawRubMutation, 'ok'>> };

export type WithdrawPartnerVariables = Exact<{
  amount: Scalars['Decimal'];
  otpCode?: Maybe<Scalars['String']>;
}>;


export type WithdrawPartner = { withdrawPartner?: Maybe<Pick<WithdrawPartnerMutation, 'ok'>> };

export type WithdrawBtcVariables = Exact<{
  amount: Scalars['Decimal'];
  address: Scalars['String'];
  otpCode?: Maybe<Scalars['String']>;
}>;


export type WithdrawBtc = { withdrawBtc?: Maybe<Pick<WithdrawBtcMutation, 'ok'>> };

export type WithdrawXmrVariables = Exact<{
  amount: Scalars['Decimal'];
  address: Scalars['String'];
  otpCode?: Maybe<Scalars['String']>;
}>;


export type WithdrawXmr = { withdrawXmr?: Maybe<Pick<WithdrawXmrMutation, 'ok'>> };

export type WithdrawLtcVariables = Exact<{
  amount: Scalars['Decimal'];
  address: Scalars['String'];
  otpCode?: Maybe<Scalars['String']>;
}>;


export type WithdrawLtc = { withdrawLtc?: Maybe<Pick<WithdrawLtcMutation, 'ok'>> };

export type WithdrawUsdtVariables = Exact<{
  amount: Scalars['Decimal'];
  address: Scalars['String'];
  otpCode?: Maybe<Scalars['String']>;
}>;


export type WithdrawUsdt = { withdrawUsdt?: Maybe<Pick<WithdrawUsdtMutation, 'ok'>> };

export type WithdrawFnkVariables = Exact<{
  amount: Scalars['Decimal'];
  address: Scalars['String'];
  otpCode?: Maybe<Scalars['String']>;
}>;


export type WithdrawFnk = { withdrawFnk?: Maybe<Pick<WithdrawFnkMutation, 'ok'>> };

export type OtcCreateAdVariables = Exact<{
  action: Scalars['String'];
  currency: Scalars['String'];
  minSum: Scalars['Decimal'];
  maxSum: Scalars['Decimal'];
  paymentMethod: Scalars['String'];
  description: Scalars['String'];
  priceExtraPercent: Scalars['Decimal'];
  phoneNumber?: Maybe<Scalars['String']>;
  bankCardNumber?: Maybe<Scalars['String']>;
  priceExtraPercentDirection: Scalars['String'];
}>;


export type OtcCreateAd = { otcCreateAd?: Maybe<Pick<OtcCreateAdMutation, 'ok'>> };

export type OtcEditAdVariables = Exact<{
  id: Scalars['String'];
  currency: Scalars['String'];
  action: Scalars['String'];
  minSum: Scalars['Decimal'];
  maxSum: Scalars['Decimal'];
  paymentMethod: Scalars['String'];
  description: Scalars['String'];
  priceExtraPercent: Scalars['Decimal'];
  phoneNumber?: Maybe<Scalars['String']>;
  bankCardNumber?: Maybe<Scalars['String']>;
  priceExtraPercentDirection: Scalars['String'];
}>;


export type OtcEditAd = { otcEditAd?: Maybe<Pick<OtcEditAdMutation, 'ok'>> };

export type OtcDeleteAdVariables = Exact<{
  pk: Scalars['String'];
}>;


export type OtcDeleteAd = { otcDeleteAd?: Maybe<Pick<OtcDeleteAdMutation, 'ok'>> };

export type OtcSetActiveAdVariables = Exact<{
  isActive: Scalars['Boolean'];
  pk: Scalars['String'];
}>;


export type OtcSetActiveAd = { otcSetActiveAd?: Maybe<Pick<OtcSetActiveAdMutation, 'ok'>> };

export type OtcStartDealVariables = Exact<{
  adId: Scalars['String'];
}>;


export type OtcStartDeal = { otcStartDeal?: Maybe<Pick<OtcStartDealMutation, 'ok' | 'dealId'>> };

export type OtcDealOfferVariables = Exact<{
  pk: Scalars['String'];
  amount: Scalars['Decimal'];
  phoneNumber?: Maybe<Scalars['String']>;
  bankCardNumber?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<Scalars['String']>;
}>;


export type OtcDealOffer = { otcDealOffer?: Maybe<Pick<OtcDealOfferMutation, 'ok'>> };

export type OtcDealAcceptVariables = Exact<{
  pk: Scalars['String'];
}>;


export type OtcDealAccept = { otcDealAccept?: Maybe<Pick<OtcDealAcceptMutation, 'ok'>> };

export type OtcDealDeclineVariables = Exact<{
  pk: Scalars['String'];
}>;


export type OtcDealDecline = { otcDealDecline?: Maybe<Pick<OtcDealDeclineMutation, 'ok'>> };

export type OtcDealPaidVariables = Exact<{
  pk: Scalars['String'];
}>;


export type OtcDealPaid = { otcDealPaid?: Maybe<Pick<OtcDealPaidMutation, 'ok'>> };

export type OtcDealCompleteVariables = Exact<{
  pk: Scalars['String'];
}>;


export type OtcDealComplete = { otcDealComplete?: Maybe<Pick<OtcDealCompleteMutation, 'ok'>> };

export type OtcDealArbitrageVariables = Exact<{
  pk: Scalars['String'];
}>;


export type OtcDealArbitrage = { otcDealArbitrage?: Maybe<Pick<OtcDealArbitrageMutation, 'ok'>> };

export type OtcDealCancelVariables = Exact<{
  pk: Scalars['String'];
}>;


export type OtcDealCancel = { otcDealCancel?: Maybe<Pick<OtcDealCancelMutation, 'ok'>> };

export type CreateOrderVariables = Exact<{
  symbol: Scalars['String'];
  direction: Scalars['String'];
  type: Scalars['String'];
  amount: Scalars['Decimal'];
  price: Scalars['Decimal'];
  turnover: Scalars['Decimal'];
}>;


export type CreateOrder = { createOrder?: Maybe<Pick<CreateOrderMutation, 'ok'>> };

export type OnCancelOrderVariables = Exact<{
  pk: Scalars['String'];
}>;


export type OnCancelOrder = { cancelOrder?: Maybe<Pick<OrderCancelMutation, 'ok'>> };

export type Referral = Pick<ReferralType, 'id' | 'referralBonuses' | 'dateJoined' | 'name' | 'avatar' | 'email'>;

export type GetProfileVariables = Exact<{ [key: string]: never; }>;


export type GetProfile = { profile?: Maybe<(
    Pick<ProfileType, 'id' | 'name' | 'email' | 'phone' | 'avatar' | 'otpEnabled' | 'otpSecret' | 'referrer' | 'emailValidated' | 'referralCode' | 'tgUsername' | 'inviterTgUsername' | 'rubBalance' | 'kztBalance' | 'uzsBalance' | 'aedBalance' | 'btcBalance' | 'xmrBalance' | 'ltcBalance' | 'usdtBalance' | 'fnkBalance' | 'partnerBalance' | 'lockedBtc' | 'lockedUsdt' | 'lockedFnk' | 'btcAddress' | 'ethAddress' | 'tronAddress' | 'xmrAddress' | 'ltcAddress'>
    & { referrals?: Maybe<Array<Referral>>, kyc?: Maybe<Pick<KycType, 'needsKyc' | 'schemaId' | 'clientKey'>> }
  )> };

export type Has2FaVariables = Exact<{
  email: Scalars['String'];
}>;


export type Has2Fa = Pick<Query, 'has2fa'>;

export type GetIndexInfoVariables = Exact<{ [key: string]: never; }>;


export type GetIndexInfo = { indexPage?: Maybe<Pick<IndexPageInfoType, 'topText' | 'topImage' | 'bottomText1' | 'bottomImage1' | 'bottomText2' | 'bottomImage2' | 'bottomText3' | 'bottomImage3'>> };

export type Operation = Pick<OperationLogType, 'id' | 'currency' | 'type' | 'value' | 'datetime' | 'status' | 'destination' | 'txid'>;

export type GetOperationsVariables = Exact<{
  currency: Scalars['String'];
}>;


export type GetOperations = { getOperations?: Maybe<{ deposits?: Maybe<Array<Operation>>, withdraws?: Maybe<Array<Operation>> }> };

export type OtcAd = (
  Pick<OtcAdType, 'id' | 'action' | 'minSum' | 'maxSum' | 'paymentMethod' | 'description' | 'priceExtraPercent' | 'priceExtraPercentDirection' | 'currency' | 'status' | 'phoneNumber' | 'bankCardNumber' | 'isActive'>
  & { user?: Maybe<Referral> }
);

export type GetMyOtcAdsVariables = Exact<{ [key: string]: never; }>;


export type GetMyOtcAds = { myAds?: Maybe<Array<OtcAd>> };

export type GetOtcAdsVariables = Exact<{ [key: string]: never; }>;


export type GetOtcAds = { ads?: Maybe<{ buy?: Maybe<Array<OtcAd>>, sell?: Maybe<Array<OtcAd>> }> };

export type OtcDeal = (
  Pick<OtcDealType, 'id' | 'datetime' | 'status' | 'amount' | 'state' | 'hasUnread' | 'phoneNumber' | 'bankCardNumber' | 'paymentMethod'>
  & { user?: Maybe<Referral>, ad?: Maybe<OtcAd> }
);

export type GetMyOtcDealsVariables = Exact<{
  startDate?: Maybe<Scalars['Date']>;
  endDate?: Maybe<Scalars['Date']>;
  minAmount?: Maybe<Scalars['Decimal']>;
  maxAmount?: Maybe<Scalars['Decimal']>;
}>;


export type GetMyOtcDeals = { myDeals?: Maybe<Array<OtcDeal>> };

export type GetDealVariables = Exact<{
  pk: Scalars['String'];
}>;


export type GetDeal = { deal?: Maybe<OtcDeal> };

export type GetBaseSymbolVariables = Exact<{ [key: string]: never; }>;


export type GetBaseSymbol = Pick<Query, 'basesymbol'>;

export type GetUserBalanceVariables = Exact<{
  symbol: Scalars['String'];
}>;


export type GetUserBalance = Pick<Query, 'getBalance'>;

export type GetCoinsVariables = Exact<{
  baseSymbol: Scalars['String'];
}>;


export type GetCoins = Pick<Query, 'coins'>;

export type GetBooksVariables = Exact<{
  symbol: Scalars['String'];
  limit: Scalars['Int'];
}>;


export type GetBooks = { books?: Maybe<{ buy?: Maybe<Array<Maybe<Pick<ExchangeOrdersType, 'type' | 'symbol' | 'price' | 'amounts' | 'turnovers' | 'amountMyOrder'>>>>, sell?: Maybe<Array<Maybe<Pick<ExchangeOrdersType, 'type' | 'symbol' | 'price' | 'amounts' | 'turnovers' | 'amountMyOrder'>>>> }> };

export type GetOrderCurrentVariables = Exact<{
  symbol: Scalars['String'];
  limit: Scalars['Int'];
  pageNo: Scalars['Int'];
}>;


export type GetOrderCurrent = { orderCurrent?: Maybe<(
    Pick<PageListType, 'count' | 'limit' | 'pageNo'>
    & { items?: Maybe<Array<Pick<ExchangeOrderType, 'orderId' | 'price' | 'type' | 'direction' | 'status' | 'amount' | 'turnover' | 'symbol' | 'time' | 'coinSymbol' | 'baseSymbol' | 'remainingAmount'>>> }
  )> };

export type GetApiAuthListVariables = Exact<{ [key: string]: never; }>;


export type GetApiAuthList = { apiAuthList?: Maybe<Array<Pick<ApiAuthType, 'id' | 'apiKey' | 'secretKey'>>> };

export type GetCoinVariables = Exact<{
  symbol: Scalars['String'];
}>;


export type GetCoin = { coin?: Maybe<Pick<CoinType, 'baseCoinScale' | 'baseSymbol' | 'coinScale' | 'coinSymbol' | 'rubRate' | 'usdRate' | 'enable' | 'fee' | 'symbol'>> };

export type GetOrderHistoryVariables = Exact<{
  symbol: Scalars['String'];
  limit: Scalars['Int'];
  pageNo: Scalars['Int'];
}>;


export type GetOrderHistory = { orderHistory?: Maybe<(
    Pick<PageListType, 'count' | 'limit' | 'pageNo'>
    & { items?: Maybe<Array<Pick<ExchangeOrderType, 'orderId' | 'price' | 'type' | 'direction' | 'status' | 'amount' | 'turnover' | 'tradedAmount' | 'tradedTurnover' | 'symbol' | 'time' | 'coinSymbol' | 'baseSymbol' | 'timeComplited' | 'timeCanceled'>>> }
  )> };

export type GetBalancesAllVariables = Exact<{ [key: string]: never; }>;


export type GetBalancesAll = { getBalancesAll?: Maybe<Array<Maybe<Pick<BalanceExchangeType, 'balance' | 'freezeBalance' | 'symbol'>>>> };

export type GetBalancesOneVariables = Exact<{
  symbol: Scalars['String'];
}>;


export type GetBalancesOne = { getBalancesOne?: Maybe<Pick<BalanceExchangeType, 'balance' | 'freezeBalance' | 'symbol'>> };

export type GetMyExmoCodesVariables = Exact<{ [key: string]: never; }>;


export type GetMyExmoCodes = { myExmoCodes?: Maybe<Array<Maybe<Pick<ExmoCodeType, 'code' | 'amount' | 'currency' | 'status' | 'createdAt' | 'activatedAt'>>>> };

export const Operation = gql`
    fragment operation on OperationLogType {
  id
  currency
  type
  value
  datetime
  status
  destination
  txid
}
    `;
export const Referral = gql`
    fragment referral on ReferralType {
  id
  referralBonuses
  dateJoined
  name
  avatar
  email
}
    `;
export const OtcAd = gql`
    fragment otcAd on OTCAdType {
  id
  user {
    ...referral
  }
  action
  minSum
  maxSum
  paymentMethod
  description
  priceExtraPercent
  priceExtraPercentDirection
  currency
  status
  phoneNumber
  bankCardNumber
  isActive
  priceExtraPercentDirection
}
    ${Referral}`;
export const OtcDeal = gql`
    fragment otcDeal on OTCDealType {
  id
  user {
    ...referral
  }
  ad {
    ...otcAd
  }
  datetime
  status
  amount
  state
  hasUnread
  phoneNumber
  bankCardNumber
  paymentMethod
}
    ${Referral}
${OtcAd}`;
export const TokenAuthDocument = gql`
    mutation tokenAuth($email: String!, $password: String!, $otpCode: String!) {
  tokenAuth(email: $email, password: $password, otpCode: $otpCode) {
    token
  }
}
    `;
export const RegisterDocument = gql`
    mutation register($name: String!, $email: String!, $password: String!, $referrer: String) {
  register(name: $name, email: $email, password: $password, referrer: $referrer) {
    ok
  }
}
    `;
export const PasswordResetDocument = gql`
    mutation passwordReset($email: String!) {
  passwordReset(email: $email) {
    ok
  }
}
    `;
export const UpdateAvatarDocument = gql`
    mutation updateAvatar($avatar: String!) {
  updateAvatar(avatar: $avatar) {
    ok
  }
}
    `;
export const UpdateNameDocument = gql`
    mutation updateName($name: String!) {
  updateName(newName: $name) {
    ok
  }
}
    `;
export const UpdatePasswordDocument = gql`
    mutation updatePassword($oldPassword: String!, $newPassword: String!) {
  updatePassword(oldPassword: $oldPassword, newPassword: $newPassword) {
    ok
  }
}
    `;
export const UpdatePhoneDocument = gql`
    mutation updatePhone($phone: String!) {
  updatePhone(newPhone: $phone) {
    ok
  }
}
    `;
export const Toggle2faDocument = gql`
    mutation toggle2fa($code: String!) {
  toggle2fa(code: $code) {
    ok
  }
}
    `;
export const TokenAuthTgDocument = gql`
    mutation tokenAuthTg($id: Int!, $firstName: String!, $username: String!, $photoUrl: String!, $authDate: Int!, $hash: String!) {
  tokenAuthTg(
    id: $id
    firstName: $firstName
    username: $username
    photoUrl: $photoUrl
    authDate: $authDate
    hash: $hash
  ) {
    token
  }
}
    `;
export const UpdateTgDocument = gql`
    mutation updateTg($tgUsername: String!, $inviterTgUsername: String) {
  updateTg(tgUsername: $tgUsername, inviterTgUsername: $inviterTgUsername) {
    ok
  }
}
    `;
export const CreateApiAuthDocument = gql`
    mutation createApiAuth {
  createApiAuth {
    ok
  }
}
    `;
export const DeleteApiAuthDocument = gql`
    mutation deleteApiAuth($id: ID!) {
  deleteApiAuth(id: $id) {
    ok
  }
}
    `;
export const DepositRubDocument = gql`
    mutation depositRub($code: String!) {
  depositRub(code: $code) {
    ok
  }
}
    `;
export const RedeemExmoCodeDocument = gql`
    mutation redeemExmoCode($code: String!) {
  redeemExmoCode(code: $code) {
    exmoCode {
      code
      amount
      currency
      status
      activatedAt
    }
    error
  }
}
    `;
export const CheckExmoCodeDocument = gql`
    mutation checkExmoCode($code: String!) {
  checkExmoCode(code: $code) {
    status
    error
  }
}
    `;
export const CreateExmoCodeDocument = gql`
    mutation createExmoCode($currency: String!, $amount: Decimal!) {
  createExmoCode(currency: $currency, amount: $amount) {
    exmoCode {
      code
      amount
      currency
      status
      createdAt
    }
    error
  }
}
    `;
export const DepositKztDocument = gql`
    mutation depositKzt($code: String!) {
  depositKzt(code: $code) {
    ok
  }
}
    `;
export const DepositUzsDocument = gql`
    mutation depositUzs($code: String!) {
  depositUzs(code: $code) {
    ok
  }
}
    `;
export const DepositAedDocument = gql`
    mutation depositAed($code: String!) {
  depositAed(code: $code) {
    ok
  }
}
    `;
export const WithdrawKztDocument = gql`
    mutation withdrawKzt($amount: Decimal!, $otpCode: String) {
  withdrawKzt(amount: $amount, otpCode: $otpCode) {
    ok
  }
}
    `;
export const WithdrawAedDocument = gql`
    mutation withdrawAed($amount: Decimal!, $otpCode: String) {
  withdrawAed(amount: $amount, otpCode: $otpCode) {
    ok
  }
}
    `;
export const WithdrawUzsDocument = gql`
    mutation withdrawUzs($amount: Decimal!, $otpCode: String) {
  withdrawUzs(amount: $amount, otpCode: $otpCode) {
    ok
  }
}
    `;
export const WithdrawRubDocument = gql`
    mutation withdrawRub($amount: Decimal!, $otpCode: String) {
  withdrawRub(amount: $amount, otpCode: $otpCode) {
    ok
  }
}
    `;
export const WithdrawPartnerDocument = gql`
    mutation withdrawPartner($amount: Decimal!, $otpCode: String) {
  withdrawPartner(amount: $amount, otpCode: $otpCode) {
    ok
  }
}
    `;
export const WithdrawBtcDocument = gql`
    mutation withdrawBtc($amount: Decimal!, $address: String!, $otpCode: String) {
  withdrawBtc(amount: $amount, address: $address, otpCode: $otpCode) {
    ok
  }
}
    `;
export const WithdrawXmrDocument = gql`
    mutation withdrawXmr($amount: Decimal!, $address: String!, $otpCode: String) {
  withdrawXmr(amount: $amount, address: $address, otpCode: $otpCode) {
    ok
  }
}
    `;
export const WithdrawLtcDocument = gql`
    mutation withdrawLtc($amount: Decimal!, $address: String!, $otpCode: String) {
  withdrawLtc(amount: $amount, address: $address, otpCode: $otpCode) {
    ok
  }
}
    `;
export const WithdrawUsdtDocument = gql`
    mutation withdrawUsdt($amount: Decimal!, $address: String!, $otpCode: String) {
  withdrawUsdt(amount: $amount, address: $address, otpCode: $otpCode) {
    ok
  }
}
    `;
export const WithdrawFnkDocument = gql`
    mutation withdrawFnk($amount: Decimal!, $address: String!, $otpCode: String) {
  withdrawFnk(amount: $amount, address: $address, otpCode: $otpCode) {
    ok
  }
}
    `;
export const OtcCreateAdDocument = gql`
    mutation otcCreateAd($action: String!, $currency: String!, $minSum: Decimal!, $maxSum: Decimal!, $paymentMethod: String!, $description: String!, $priceExtraPercent: Decimal!, $phoneNumber: String, $bankCardNumber: String, $priceExtraPercentDirection: String!) {
  otcCreateAd(
    action: $action
    currency: $currency
    minSum: $minSum
    maxSum: $maxSum
    paymentMethod: $paymentMethod
    description: $description
    priceExtraPercent: $priceExtraPercent
    phoneNumber: $phoneNumber
    bankCardNumber: $bankCardNumber
    priceExtraPercentDirection: $priceExtraPercentDirection
  ) {
    ok
  }
}
    `;
export const OtcEditAdDocument = gql`
    mutation otcEditAd($id: String!, $currency: String!, $action: String!, $minSum: Decimal!, $maxSum: Decimal!, $paymentMethod: String!, $description: String!, $priceExtraPercent: Decimal!, $phoneNumber: String, $bankCardNumber: String, $priceExtraPercentDirection: String!) {
  otcEditAd(
    id: $id
    action: $action
    currency: $currency
    minSum: $minSum
    maxSum: $maxSum
    paymentMethod: $paymentMethod
    description: $description
    priceExtraPercent: $priceExtraPercent
    phoneNumber: $phoneNumber
    bankCardNumber: $bankCardNumber
    priceExtraPercentDirection: $priceExtraPercentDirection
  ) {
    ok
  }
}
    `;
export const OtcDeleteAdDocument = gql`
    mutation otcDeleteAd($pk: String!) {
  otcDeleteAd(pk: $pk) {
    ok
  }
}
    `;
export const OtcSetActiveAdDocument = gql`
    mutation otcSetActiveAd($isActive: Boolean!, $pk: String!) {
  otcSetActiveAd(pk: $pk, isActive: $isActive) {
    ok
  }
}
    `;
export const OtcStartDealDocument = gql`
    mutation otcStartDeal($adId: String!) {
  otcStartDeal(adId: $adId) {
    ok
    dealId
  }
}
    `;
export const OtcDealOfferDocument = gql`
    mutation otcDealOffer($pk: String!, $amount: Decimal!, $phoneNumber: String, $bankCardNumber: String, $paymentMethod: String) {
  otcDealOffer(
    pk: $pk
    amount: $amount
    phoneNumber: $phoneNumber
    bankCardNumber: $bankCardNumber
    paymentMethod: $paymentMethod
  ) {
    ok
  }
}
    `;
export const OtcDealAcceptDocument = gql`
    mutation otcDealAccept($pk: String!) {
  otcDealAccept(pk: $pk) {
    ok
  }
}
    `;
export const OtcDealDeclineDocument = gql`
    mutation otcDealDecline($pk: String!) {
  otcDealDecline(pk: $pk) {
    ok
  }
}
    `;
export const OtcDealPaidDocument = gql`
    mutation otcDealPaid($pk: String!) {
  otcDealPaid(pk: $pk) {
    ok
  }
}
    `;
export const OtcDealCompleteDocument = gql`
    mutation otcDealComplete($pk: String!) {
  otcDealComplete(pk: $pk) {
    ok
  }
}
    `;
export const OtcDealArbitrageDocument = gql`
    mutation otcDealArbitrage($pk: String!) {
  otcDealArbitrage(pk: $pk) {
    ok
  }
}
    `;
export const OtcDealCancelDocument = gql`
    mutation otcDealCancel($pk: String!) {
  otcDealCancel(pk: $pk) {
    ok
  }
}
    `;
export const CreateOrderDocument = gql`
    mutation createOrder($symbol: String!, $direction: String!, $type: String!, $amount: Decimal!, $price: Decimal!, $turnover: Decimal!) {
  createOrder(
    symbol: $symbol
    amount: $amount
    type: $type
    direction: $direction
    price: $price
    turnover: $turnover
  ) {
    ok
  }
}
    `;
export const OnCancelOrderDocument = gql`
    mutation onCancelOrder($pk: String!) {
  cancelOrder(pk: $pk) {
    ok
  }
}
    `;
export const GetProfileDocument = gql`
    query getProfile {
  profile {
    id
    name
    email
    phone
    avatar
    otpEnabled
    otpSecret
    referrer
    emailValidated
    referralCode
    tgUsername
    inviterTgUsername
    rubBalance
    kztBalance
    uzsBalance
    aedBalance
    btcBalance
    xmrBalance
    ltcBalance
    usdtBalance
    fnkBalance
    partnerBalance
    lockedBtc
    lockedUsdt
    lockedFnk
    btcAddress
    ethAddress
    tronAddress
    xmrAddress
    ltcAddress
    referrals {
      ...referral
    }
    kyc {
      needsKyc
      schemaId
      clientKey
    }
  }
}
    ${Referral}`;
export const Has2FaDocument = gql`
    query has2FA($email: String!) {
  has2fa(email: $email)
}
    `;
export const GetIndexInfoDocument = gql`
    query getIndexInfo {
  indexPage {
    topText
    topImage
    bottomText1
    bottomImage1
    bottomText2
    bottomImage2
    bottomText3
    bottomImage3
  }
}
    `;
export const GetOperationsDocument = gql`
    query getOperations($currency: String!) {
  getOperations(currency: $currency) {
    deposits {
      ...operation
    }
    withdraws {
      ...operation
    }
  }
}
    ${Operation}`;
export const GetMyOtcAdsDocument = gql`
    query getMyOtcAds {
  myAds {
    ...otcAd
  }
}
    ${OtcAd}`;
export const GetOtcAdsDocument = gql`
    query getOtcAds {
  ads {
    buy {
      ...otcAd
    }
    sell {
      ...otcAd
    }
  }
}
    ${OtcAd}`;
export const GetMyOtcDealsDocument = gql`
    query getMyOtcDeals($startDate: Date, $endDate: Date, $minAmount: Decimal, $maxAmount: Decimal) {
  myDeals(
    startDate: $startDate
    endDate: $endDate
    minAmount: $minAmount
    maxAmount: $maxAmount
  ) {
    ...otcDeal
  }
}
    ${OtcDeal}`;
export const GetDealDocument = gql`
    query getDeal($pk: String!) {
  deal(pk: $pk) {
    ...otcDeal
  }
}
    ${OtcDeal}`;
export const GetBaseSymbolDocument = gql`
    query getBaseSymbol {
  basesymbol
}
    `;
export const GetUserBalanceDocument = gql`
    query getUserBalance($symbol: String!) {
  getBalance(symbol: $symbol)
}
    `;
export const GetCoinsDocument = gql`
    query getCoins($baseSymbol: String!) {
  coins(baseSymbol: $baseSymbol)
}
    `;
export const GetBooksDocument = gql`
    query getBooks($symbol: String!, $limit: Int!) {
  books(symbol: $symbol, limit: $limit) {
    buy {
      type
      symbol
      price
      amounts
      turnovers
      amountMyOrder
    }
    sell {
      type
      symbol
      price
      amounts
      turnovers
      amountMyOrder
    }
  }
}
    `;
export const GetOrderCurrentDocument = gql`
    query getOrderCurrent($symbol: String!, $limit: Int!, $pageNo: Int!) {
  orderCurrent(symbol: $symbol, limit: $limit, pageNo: $pageNo) {
    count
    limit
    pageNo
    items {
      orderId
      price
      type
      direction
      status
      amount
      turnover
      symbol
      time
      coinSymbol
      baseSymbol
      remainingAmount
    }
  }
}
    `;
export const GetApiAuthListDocument = gql`
    query getApiAuthList {
  apiAuthList {
    id
    apiKey
    secretKey
  }
}
    `;
export const GetCoinDocument = gql`
    query getCoin($symbol: String!) {
  coin(symbol: $symbol) {
    baseCoinScale
    baseSymbol
    coinScale
    coinSymbol
    rubRate
    usdRate
    enable
    fee
    symbol
  }
}
    `;
export const GetOrderHistoryDocument = gql`
    query getOrderHistory($symbol: String!, $limit: Int!, $pageNo: Int!) {
  orderHistory(symbol: $symbol, limit: $limit, pageNo: $pageNo) {
    count
    limit
    pageNo
    items {
      orderId
      price
      type
      direction
      status
      amount
      turnover
      tradedAmount
      tradedTurnover
      symbol
      time
      coinSymbol
      baseSymbol
      timeComplited
      timeCanceled
    }
  }
}
    `;
export const GetBalancesAllDocument = gql`
    query getBalancesAll {
  getBalancesAll {
    balance
    freezeBalance
    symbol
  }
}
    `;
export const GetBalancesOneDocument = gql`
    query getBalancesOne($symbol: String!) {
  getBalancesOne(symbol: $symbol) {
    balance
    freezeBalance
    symbol
  }
}
    `;
export const GetMyExmoCodesDocument = gql`
    query getMyExmoCodes {
  myExmoCodes {
    code
    amount
    currency
    status
    createdAt
    activatedAt
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    tokenAuth(variables: TokenAuthVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<TokenAuth> {
      return withWrapper((wrappedRequestHeaders) => client.request<TokenAuth>(TokenAuthDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'tokenAuth');
    },
    register(variables: RegisterVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<Register> {
      return withWrapper((wrappedRequestHeaders) => client.request<Register>(RegisterDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'register');
    },
    passwordReset(variables: PasswordResetVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<PasswordReset> {
      return withWrapper((wrappedRequestHeaders) => client.request<PasswordReset>(PasswordResetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'passwordReset');
    },
    updateAvatar(variables: UpdateAvatarVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateAvatar> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateAvatar>(UpdateAvatarDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateAvatar');
    },
    updateName(variables: UpdateNameVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateName> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateName>(UpdateNameDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateName');
    },
    updatePassword(variables: UpdatePasswordVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdatePassword> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePassword>(UpdatePasswordDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updatePassword');
    },
    updatePhone(variables: UpdatePhoneVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdatePhone> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePhone>(UpdatePhoneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updatePhone');
    },
    toggle2fa(variables: Toggle2faVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<Toggle2fa> {
      return withWrapper((wrappedRequestHeaders) => client.request<Toggle2fa>(Toggle2faDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'toggle2fa');
    },
    tokenAuthTg(variables: TokenAuthTgVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<TokenAuthTg> {
      return withWrapper((wrappedRequestHeaders) => client.request<TokenAuthTg>(TokenAuthTgDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'tokenAuthTg');
    },
    updateTg(variables: UpdateTgVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateTg> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateTg>(UpdateTgDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateTg');
    },
    createApiAuth(variables?: CreateApiAuthVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateApiAuth> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateApiAuth>(CreateApiAuthDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createApiAuth');
    },
    deleteApiAuth(variables: DeleteApiAuthVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteApiAuth> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteApiAuth>(DeleteApiAuthDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteApiAuth');
    },
    depositRub(variables: DepositRubVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DepositRub> {
      return withWrapper((wrappedRequestHeaders) => client.request<DepositRub>(DepositRubDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'depositRub');
    },
    redeemExmoCode(variables: RedeemExmoCodeVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<RedeemExmoCode> {
      return withWrapper((wrappedRequestHeaders) => client.request<RedeemExmoCode>(RedeemExmoCodeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'redeemExmoCode');
    },
    checkExmoCode(variables: CheckExmoCodeVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CheckExmoCode> {
      return withWrapper((wrappedRequestHeaders) => client.request<CheckExmoCode>(CheckExmoCodeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'checkExmoCode');
    },
    createExmoCode(variables: CreateExmoCodeVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateExmoCode> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateExmoCode>(CreateExmoCodeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createExmoCode');
    },
    depositKzt(variables: DepositKztVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DepositKzt> {
      return withWrapper((wrappedRequestHeaders) => client.request<DepositKzt>(DepositKztDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'depositKzt');
    },
    depositUzs(variables: DepositUzsVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DepositUzs> {
      return withWrapper((wrappedRequestHeaders) => client.request<DepositUzs>(DepositUzsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'depositUzs');
    },
    depositAed(variables: DepositAedVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DepositAed> {
      return withWrapper((wrappedRequestHeaders) => client.request<DepositAed>(DepositAedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'depositAed');
    },
    withdrawKzt(variables: WithdrawKztVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<WithdrawKzt> {
      return withWrapper((wrappedRequestHeaders) => client.request<WithdrawKzt>(WithdrawKztDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'withdrawKzt');
    },
    withdrawAed(variables: WithdrawAedVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<WithdrawAed> {
      return withWrapper((wrappedRequestHeaders) => client.request<WithdrawAed>(WithdrawAedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'withdrawAed');
    },
    withdrawUzs(variables: WithdrawUzsVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<WithdrawUzs> {
      return withWrapper((wrappedRequestHeaders) => client.request<WithdrawUzs>(WithdrawUzsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'withdrawUzs');
    },
    withdrawRub(variables: WithdrawRubVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<WithdrawRub> {
      return withWrapper((wrappedRequestHeaders) => client.request<WithdrawRub>(WithdrawRubDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'withdrawRub');
    },
    withdrawPartner(variables: WithdrawPartnerVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<WithdrawPartner> {
      return withWrapper((wrappedRequestHeaders) => client.request<WithdrawPartner>(WithdrawPartnerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'withdrawPartner');
    },
    withdrawBtc(variables: WithdrawBtcVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<WithdrawBtc> {
      return withWrapper((wrappedRequestHeaders) => client.request<WithdrawBtc>(WithdrawBtcDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'withdrawBtc');
    },
    withdrawXmr(variables: WithdrawXmrVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<WithdrawXmr> {
      return withWrapper((wrappedRequestHeaders) => client.request<WithdrawXmr>(WithdrawXmrDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'withdrawXmr');
    },
    withdrawLtc(variables: WithdrawLtcVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<WithdrawLtc> {
      return withWrapper((wrappedRequestHeaders) => client.request<WithdrawLtc>(WithdrawLtcDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'withdrawLtc');
    },
    withdrawUsdt(variables: WithdrawUsdtVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<WithdrawUsdt> {
      return withWrapper((wrappedRequestHeaders) => client.request<WithdrawUsdt>(WithdrawUsdtDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'withdrawUsdt');
    },
    withdrawFnk(variables: WithdrawFnkVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<WithdrawFnk> {
      return withWrapper((wrappedRequestHeaders) => client.request<WithdrawFnk>(WithdrawFnkDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'withdrawFnk');
    },
    otcCreateAd(variables: OtcCreateAdVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<OtcCreateAd> {
      return withWrapper((wrappedRequestHeaders) => client.request<OtcCreateAd>(OtcCreateAdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'otcCreateAd');
    },
    otcEditAd(variables: OtcEditAdVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<OtcEditAd> {
      return withWrapper((wrappedRequestHeaders) => client.request<OtcEditAd>(OtcEditAdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'otcEditAd');
    },
    otcDeleteAd(variables: OtcDeleteAdVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<OtcDeleteAd> {
      return withWrapper((wrappedRequestHeaders) => client.request<OtcDeleteAd>(OtcDeleteAdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'otcDeleteAd');
    },
    otcSetActiveAd(variables: OtcSetActiveAdVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<OtcSetActiveAd> {
      return withWrapper((wrappedRequestHeaders) => client.request<OtcSetActiveAd>(OtcSetActiveAdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'otcSetActiveAd');
    },
    otcStartDeal(variables: OtcStartDealVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<OtcStartDeal> {
      return withWrapper((wrappedRequestHeaders) => client.request<OtcStartDeal>(OtcStartDealDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'otcStartDeal');
    },
    otcDealOffer(variables: OtcDealOfferVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<OtcDealOffer> {
      return withWrapper((wrappedRequestHeaders) => client.request<OtcDealOffer>(OtcDealOfferDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'otcDealOffer');
    },
    otcDealAccept(variables: OtcDealAcceptVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<OtcDealAccept> {
      return withWrapper((wrappedRequestHeaders) => client.request<OtcDealAccept>(OtcDealAcceptDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'otcDealAccept');
    },
    otcDealDecline(variables: OtcDealDeclineVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<OtcDealDecline> {
      return withWrapper((wrappedRequestHeaders) => client.request<OtcDealDecline>(OtcDealDeclineDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'otcDealDecline');
    },
    otcDealPaid(variables: OtcDealPaidVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<OtcDealPaid> {
      return withWrapper((wrappedRequestHeaders) => client.request<OtcDealPaid>(OtcDealPaidDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'otcDealPaid');
    },
    otcDealComplete(variables: OtcDealCompleteVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<OtcDealComplete> {
      return withWrapper((wrappedRequestHeaders) => client.request<OtcDealComplete>(OtcDealCompleteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'otcDealComplete');
    },
    otcDealArbitrage(variables: OtcDealArbitrageVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<OtcDealArbitrage> {
      return withWrapper((wrappedRequestHeaders) => client.request<OtcDealArbitrage>(OtcDealArbitrageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'otcDealArbitrage');
    },
    otcDealCancel(variables: OtcDealCancelVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<OtcDealCancel> {
      return withWrapper((wrappedRequestHeaders) => client.request<OtcDealCancel>(OtcDealCancelDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'otcDealCancel');
    },
    createOrder(variables: CreateOrderVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateOrder> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateOrder>(CreateOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createOrder');
    },
    onCancelOrder(variables: OnCancelOrderVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<OnCancelOrder> {
      return withWrapper((wrappedRequestHeaders) => client.request<OnCancelOrder>(OnCancelOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'onCancelOrder');
    },
    getProfile(variables?: GetProfileVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetProfile> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetProfile>(GetProfileDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getProfile');
    },
    has2FA(variables: Has2FaVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<Has2Fa> {
      return withWrapper((wrappedRequestHeaders) => client.request<Has2Fa>(Has2FaDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'has2FA');
    },
    getIndexInfo(variables?: GetIndexInfoVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetIndexInfo> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetIndexInfo>(GetIndexInfoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getIndexInfo');
    },
    getOperations(variables: GetOperationsVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOperations> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOperations>(GetOperationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOperations');
    },
    getMyOtcAds(variables?: GetMyOtcAdsVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetMyOtcAds> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetMyOtcAds>(GetMyOtcAdsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getMyOtcAds');
    },
    getOtcAds(variables?: GetOtcAdsVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOtcAds> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOtcAds>(GetOtcAdsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOtcAds');
    },
    getMyOtcDeals(variables?: GetMyOtcDealsVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetMyOtcDeals> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetMyOtcDeals>(GetMyOtcDealsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getMyOtcDeals');
    },
    getDeal(variables: GetDealVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetDeal> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetDeal>(GetDealDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getDeal');
    },
    getBaseSymbol(variables?: GetBaseSymbolVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetBaseSymbol> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBaseSymbol>(GetBaseSymbolDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getBaseSymbol');
    },
    getUserBalance(variables: GetUserBalanceVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetUserBalance> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUserBalance>(GetUserBalanceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getUserBalance');
    },
    getCoins(variables: GetCoinsVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetCoins> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCoins>(GetCoinsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getCoins');
    },
    getBooks(variables: GetBooksVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetBooks> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBooks>(GetBooksDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getBooks');
    },
    getOrderCurrent(variables: GetOrderCurrentVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOrderCurrent> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOrderCurrent>(GetOrderCurrentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOrderCurrent');
    },
    getApiAuthList(variables?: GetApiAuthListVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetApiAuthList> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetApiAuthList>(GetApiAuthListDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getApiAuthList');
    },
    getCoin(variables: GetCoinVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetCoin> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCoin>(GetCoinDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getCoin');
    },
    getOrderHistory(variables: GetOrderHistoryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOrderHistory> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOrderHistory>(GetOrderHistoryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOrderHistory');
    },
    getBalancesAll(variables?: GetBalancesAllVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetBalancesAll> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBalancesAll>(GetBalancesAllDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getBalancesAll');
    },
    getBalancesOne(variables: GetBalancesOneVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetBalancesOne> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBalancesOne>(GetBalancesOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getBalancesOne');
    },
    getMyExmoCodes(variables?: GetMyExmoCodesVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetMyExmoCodes> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetMyExmoCodes>(GetMyExmoCodesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getMyExmoCodes');
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;